<nav aria-label="breadcrumb">
    <ol class="breadcrumb nav-breadcrumb pl-5">
      <li><fa-icon [icon]="faUser" class="mr-2 h2"></fa-icon></li>
      <li class="breadcrumb-item"><a routerLink="/admin" class="text-primary-color-3">{{ "home.administration" | translate }}</a></li>
      <li class="breadcrumb-item" aria-current="page"><a routerLink="/sales-agent" class="text-primary-color-3">{{ "admin.sales-agent" | translate }}</a></li>
    </ol>
  </nav> 
  <div class="d-flex justify-content-center pt-3">
      <div class="col-md-10">
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="bg-form shadow">
          <div class="d-flex justify-content-center">
            <div class="col-md-6 text-center">
              <h5>{{ "admin.sales-agent" | translate }}</h5>
            </div>
          </div>
          <div class="form-group">
            <label for="name">{{ "sales-agent.name" | translate }}:</label>
            <input class="form-control" [readonly]="view()" formControlName="name" type="text" [ngClass]="{ 'is-invalid': submitted && f.name.errors }">
            <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                <div *ngIf="f.name.errors.required">{{ "general.required" | translate }}</div>
            </div>
          </div>
          <div class="form-group">
            <label for="telephone">{{ "sales-agent.phone" | translate }}:</label>
            <input class="form-control" [readonly]="view()" formControlName="telephone" type="text" [ngClass]="{ 'is-invalid': submitted && f.telephone.errors }">
            <div *ngIf="submitted && f.telephone.errors" class="invalid-feedback">
                <div *ngIf="f.telephone.errors.required">{{ "general.required" | translate }}</div>
            </div>
          </div>
          <div class="form-group">
            <label for="email">{{ "sales-agent.email" | translate }}:</label>
            <input class="form-control" [readonly]="view()" formControlName="email" type="text" [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                <div *ngIf="f.email.errors.required">{{ "general.required" | translate }}</div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-danger mr-3" routerLink="/sales-agent">{{ "form.cancel" | translate }}</button>
            <button type="submit" class="btn btn-primary" *ngIf="create()" >{{ "form.save" | translate }}</button>
            <button type="submit" class="btn btn-primary" *ngIf="edit()" >{{ "form.update" | translate }}</button>
          </div>
        </form>
      </div>
  </div>




